import React from "react";
import { MessageWithAvatar } from "../../../../../core/atoms/atoms";

interface InitialMessageProps {
  country: ICountry;
}

export const InitialMessage: React.FC<InitialMessageProps> = (props) => {
  const { country } = props;

  const avatar = country?.images?.find(
    image => image.locationImageType === LocationImageType.LtoMain
  ) ?? country?.defaultLto?.image;

  const messageWithAvatarProps = {
    avatarUrl: avatar?.thumbnailUrl,
    avatarName: `Your experts in ${country.name}`,
  }

  return (
    <MessageWithAvatar
      {...messageWithAvatarProps}
    >
      <h3>
        Hi, we&apos;re {country?.defaultLto.name} in {country?.name}. {` `}
        We&apos;ll be in touch shortly so we can start planning your trip together...
      </h3>
      <p>{country?.defaultLto.publicSpeciality}</p>
    </MessageWithAvatar>
  );
}
